<template>
    <v-card v-if="edit_mode">
        <v-form v-model="valid">
            <v-card-title>
                <v-text-field :rules="rules.title" v-model="purchase.title" :loading="save_loading"
                              clearable
                              label="Название для закупки"
                              hint="Введите название для своей закупки"></v-text-field>
            </v-card-title>
            <v-card-subtitle>
                <v-textarea v-model="purchase.info" rows="2"
                            :loading="save_loading"
                            label="Дополнительная информация"
                            hint="Любой комментарий (какие-то новости и т.п.)"></v-textarea>
            </v-card-subtitle>
            <v-card-text>
                <v-datetime-picker
                    :loading="save_loading"
                    label="Дата начала закупки"
                    date-format="dd.MM.yyyy"
                    clear-text="Очистить"
                    ok-text="Готово"
                    :date-picker-props="{locale: 'ru-ru', firstDayOfWeek: 1}"
                    :time-picker-props="{locale: 'ru-ru', format: '24hr'}"
                    :text-field-props="{rules: rules.required}"
                    v-model="buyout_date_start">
                    <template slot="dateIcon">
                        <v-icon>{{ icon_calendar }}</v-icon>
                    </template>
                    <template slot="timeIcon">
                        <v-icon>{{ icon_clock }}</v-icon>
                    </template>
                </v-datetime-picker>
                <v-datetime-picker
                    :loading="save_loading"
                    label="Дата окончания закупки"
                    date-format="dd.MM.yyyy"
                    clear-text="Очистить"
                    ok-text="Готово"
                    :date-picker-props="{locale: 'ru-ru', firstDayOfWeek: 1}"
                    :time-picker-props="{locale: 'ru-ru', format: '24hr'}"
                    :text-field-props="{rules: rules.required}"
                    v-model="buyout_date_end">
                    <template slot="dateIcon">
                        <v-icon>{{ icon_calendar }}</v-icon>
                    </template>
                    <template slot="timeIcon">
                        <v-icon>{{ icon_clock }}</v-icon>
                    </template>
                </v-datetime-picker>
                <v-datetime-picker
                    :loading="save_loading"
                    label="Дата начала добавления заказов"
                    date-format="dd.MM.yyyy"
                    clear-text="Очистить"
                    ok-text="Готово"
                    :date-picker-props="{locale: 'ru-ru', firstDayOfWeek: 1}"
                    :time-picker-props="{locale: 'ru-ru', format: '24hr'}"
                    :text-field-props="{rules: rules.required}"
                    v-model="load_date_start">
                    <template slot="dateIcon">
                        <v-icon>{{ icon_calendar }}</v-icon>
                    </template>
                    <template slot="timeIcon">
                        <v-icon>{{ icon_clock }}</v-icon>
                    </template>
                </v-datetime-picker>
                <v-datetime-picker
                    :loading="save_loading"
                    label="Дата окончания добавления заказов"
                    date-format="dd.MM.yyyy"
                    clear-text="Очистить"
                    ok-text="Готово"
                    :date-picker-props="{locale: 'ru-ru', firstDayOfWeek: 1}"
                    :time-picker-props="{locale: 'ru-ru', format: '24hr'}"
                    :text-field-props="{rules: rules.required}"
                    v-model="load_date_end">
                    <template slot="dateIcon">
                        <v-icon>{{ icon_calendar }}</v-icon>
                    </template>
                    <template slot="timeIcon">
                        <v-icon>{{ icon_clock }}</v-icon>
                    </template>
                </v-datetime-picker>
                <v-datetime-picker
                    :loading="save_loading"
                    label="Дата окончания оплаты заказов"
                    date-format="dd.MM.yyyy"
                    clear-text="Очистить"
                    ok-text="Готово"
                    :date-picker-props="{locale: 'ru-ru', firstDayOfWeek: 1}"
                    :time-picker-props="{locale: 'ru-ru', format: '24hr'}"
                    :text-field-props="{rules: rules.required}"
                    v-model="pay_date_end">
                    <template slot="dateIcon">
                        <v-icon>{{ icon_calendar }}</v-icon>
                    </template>
                    <template slot="timeIcon">
                        <v-icon>{{ icon_clock }}</v-icon>
                    </template>
                </v-datetime-picker>
                <v-switch
                    :loading="save_loading"
                    v-model="purchase.backorder"
                    inset
                >
                    <template v-slot:append>
                        <v-btn style="margin-top: -8px" @click="onSettingsBackorder" icon>
                            <v-icon>{{ icon_settings }}</v-icon>
                        </v-btn>
                    </template>
                    <template v-slot:label>
                        Режим дозаказа (для опытных)
                        <v-tooltip top max-width="340">
                            <template v-slot:activator="{ on }">
                                <v-icon right class="grey--text" v-on="on">{{ icon_help }}</v-icon>
                            </template>
                            При включенном режиме дозаказа ваши клиенты смогут добавлять заказы во
                            время вашей закупки вне зависимости от дат загрузки, но только на места, где
                            есть заказы в статусе "Ожидает" (то есть места которые вы ещё не прошли на
                            рынке)
                        </v-tooltip>
                    </template>
                </v-switch>
            </v-card-text>
            <v-divider></v-divider>
            <v-container fluid class="py-0">
                <v-row>
                    <v-col class="text-right">
                        <v-btn :disabled="save_loading" rounded
                               class="text-none font-weight-regular body-2 seccondary mr-2" @click="cancelEdit">
                            Отмена
                        </v-btn>
                        <v-btn rounded :loading="save_loading" :disabled="!valid"
                               class="text-none font-weight-regular body-2 success" @click="onSave">
                            Сохранить
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-form>
    </v-card>
    <v-card v-else-if="delete_mode">
        <v-card-title>
            <v-container fluid class="py-0">
                <v-row align="center">
                    <v-col cols="12" class="pa-0">
                        Удаление закупки
                    </v-col>
                </v-row>
            </v-container>
        </v-card-title>

        <v-divider></v-divider>

        <v-container>
            <v-row style="height: 340px;" justify="center" align="center">
                <v-col cols="12">
                    <v-col align-self="center" class="text-center pb-0" cols="12">
                        Удалить закупку "{{ purchase.title }}"?
                    </v-col>
                    <v-col class="text-center" cols="12">
                        <v-btn rounded :disabled="delete_loading"
                               class="text-none font-weight-regular body-2 seccondary mr-1" @click="delete_mode=false">
                            Нет
                        </v-btn>
                        <v-btn rounded class="text-none font-weight-regular body-2 error" :loading="delete_loading"
                               @click="onDelete">
                            Да
                        </v-btn>
                    </v-col>
                </v-col>
            </v-row>
        </v-container>

    </v-card>
    <v-card v-else>
        <v-card-title>
            <v-container fluid class="py-0">
                <v-row align="center">
                    <v-col cols="10" class="pa-0">
                        <div style="line-height: 24px">{{ purchase.title }}</div>
                        <div class="caption text--secondary">
                            #{{ purchase.id }}
                            <span v-if="purchase.pinned">| Закупка закреплена</span>
                        </div>
                    </v-col>
                    <v-col cols="2" class="pa-0 text-right">
                        <v-menu bottom left transition="slide-y-transition">
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" icon>
                                    <v-icon class="grey--text">
                                        {{ icon_tooltip }}
                                    </v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item
                                    v-for="(item, i) in items"
                                    :key="i"
                                    @click.stop="item.action"
                                    :style="{
                                                color: item.color ? `${item.color}!important` : false,
                                                opacity: item.disabled() ? 0.5 : 1,}"
                                    :disabled="item.disabled()">
                                    <v-list-item-icon>
                                        <v-icon :style="{color: item.color || false}" right>{{ item.icon }}</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-subtitle style="white-space: pre-line" v-show="purchase.info">
            {{ purchase.info }}
        </v-card-subtitle>
        <v-card-text>
            <v-divider v-show="purchase.info"></v-divider>

            <v-row align="center">
                <v-col cols="12" class="pb-1">
                    <span style="color: rgba(0,0,0,.87)">Период закупки</span>
                    <span v-if="buyout_days_left !== -1" v-html="buyout_days_left"></span>
                    <span v-else>
                            <span class="error--text"> - Окончена</span>
                        </span>
                </v-col>
                <v-col class="caption text--secondary pt-0" cols="12"
                       style="color: rgba(0,0,0,.87)">
                    от {{ purchase.buyout_date_start|localize('dd.MM.yyyy HH:mm') }}
                    до {{ purchase.buyout_date_end|localize('dd.MM.yyyy HH:mm') }}
                </v-col>
            </v-row>

            <v-divider></v-divider>

            <v-row align="center">
                <v-col cols="12" class="pb-1">
                    <span style="color: rgba(0,0,0,.87)">Добавление заказов</span>
                    <span v-if="load_days_left !== -1" v-html="load_days_left"></span>
                    <span v-else>
                            <span class="error--text"> - Окончена</span>
                        </span>
                </v-col>
                <v-col class="caption text--secondary pt-0" cols="12"
                       style="color: rgba(0,0,0,.87)">
                    от {{ purchase.load_date_start|localize('dd.MM.yyyy HH:mm') }}
                    до {{ purchase.load_date_end|localize('dd.MM.yyyy HH:mm') }}
                </v-col>
            </v-row>

            <v-divider></v-divider>

            <v-row align="center">
                <v-col cols="12" class="pb-1">
                    <span style="color: rgba(0,0,0,.87)">Оплата заказов</span>
                    <span v-if="pay_days_left !== -1" v-html="pay_days_left"></span>
                    <span v-else>
                            <span class="error--text"> - Окончена</span>
                        </span>
                </v-col>
                <v-col class="caption text--secondary pt-0" cols="12"
                       style="color: rgba(0,0,0,.87)">
                    до {{ purchase.pay_date_end|localize('dd.MM.yyyy HH:mm') }}
                </v-col>
            </v-row>

            <v-divider></v-divider>

            <v-row align="center">
                <v-col cols="12" class="pb-2">
                    <span style="color: rgba(0,0,0,.87)">Режим дозаказа</span>
                    <span v-if="purchase.backorder" class="success--text"> - Включен</span>
                    <span v-else class="error--text"> - Отключен</span>
                </v-col>
            </v-row>
        </v-card-text>
        <v-expansion-panels v-model="show_total" v-if="has_perm('total_purchase')" class="total-collapse">
            <v-expansion-panel>
                <v-expansion-panel-header @click="onShowTotal">
                    <div class="row align-center">
                        <span class="title mr-2">Итоги</span>
                        <span class="subtitle-2">(нажмите чтобы посмотреть)</span>
                    </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-container class="pa-0" fluid>
                        <v-row>
                            <total-cell :error="error_total_loading" :loading="total_loading" cols="6"
                                        title="Всего заказано">
                                <template #tooltip>
                                    Заказы({{ total.order_count_all }}шт) + Сборы({{ total.collection_count_all }}шт) =
                                    {{ total.order_count_all + total.collection_count_all }}шт
                                </template>
                                {{ total.count }}<span class="text--secondary">шт</span>
                            </total-cell>
                            <total-cell :error="error_total_loading" :loading="total_loading" cols="6"
                                        title="Cумма заказов">
                                <template #default>
                                    {{ +(order_total_all + collection_total_all).toFixed(2) }}<span
                                    class="text--secondary">₽</span>
                                </template>
                                <template #tooltip>
                                    Заказы:<br>{{ +(total.order_price_all - total.order_prepayment_all).toFixed(2) }}₽ +
                                    %({{ total.order_org_all }}₽) = {{ order_total_all }}₽<br>
                                    <v-divider color="white" class="my-1"></v-divider>
                                    Сборы:<br>{{
                                        +(total.collection_price_all - total.collection_prepayment_all).toFixed(2)
                                    }}₽ + %({{ total.collection_org_all }}₽) = {{ collection_total_all }}₽<br>
                                    <v-divider color="white" class="my-1"></v-divider>
                                    Итого:<br>{{
                                        +(total.order_price_all + total.collection_price_all - total.order_prepayment_all - total.collection_prepayment_all).toFixed(2)
                                    }}₽ + %({{ +(total.order_org_all + total.collection_org_all).toFixed(2) }}₽) =
                                    {{ +(order_total_all + collection_total_all).toFixed(2) }}₽
                                </template>
                            </total-cell>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row>
                            <total-cell :error="error_total_loading" :loading="total_loading" cols="6"
                                        title="Куплено">
                                <template #tooltip>
                                    Заказы({{ total.order_count_purchased }}шт) +
                                    Сборы({{ total.collection_count_purchased }}шт) =
                                    {{ total.order_count_purchased + total.collection_count_purchased }}шт
                                </template>
                                {{ total.order_count_purchased + total.collection_count_purchased }}<span
                                class="text--secondary">шт</span>
                            </total-cell>
                            <total-cell :error="error_total_loading" :loading="total_loading" cols="6"
                                        title="Cумма выкупа">
                                <template #default>
                                    {{ +(order_total_purchased + collection_total_purchased).toFixed(2) }}<span
                                    class="text--secondary">₽</span>
                                </template>
                                <template #tooltip>
                                    Заказы:<br>{{
                                        +(total.order_price_purchased - total.order_prepayment_purchased).toFixed(2)
                                    }}₽ + %({{ total.order_org_purchased }}₽) = {{ order_total_purchased }}₽<br>
                                    <v-divider color="white" class="my-1"></v-divider>
                                    Сборы:<br>{{
                                        +(total.collection_price_purchased - total.collection_prepayment_purchased).toFixed(2)
                                    }}₽ + %({{ total.collection_org_purchased }}₽) = {{
                                        collection_total_purchased
                                    }}₽<br>
                                    <v-divider color="white" class="my-1"></v-divider>
                                    Итого:<br>{{
                                        +(total.order_price_purchased + total.collection_price_purchased - total.order_prepayment_purchased - total.collection_prepayment_purchased).toFixed(2)
                                    }}₽ + %({{
                                        +(total.order_org_purchased + total.collection_org_purchased).toFixed(2)
                                    }}₽) = {{ +(order_total_purchased + collection_total_purchased).toFixed(2) }}₽
                                </template>
                            </total-cell>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row>
                            <total-cell :error="error_total_loading" :loading="total_loading" cols="6"
                                        title="Невыкуплено">
                                <template #tooltip>
                                    Заказы({{ total.order_count_not_purchased }}шт) +
                                    Сборы({{ total.collection_count_not_purchased }}шт) =
                                    {{ total.order_count_not_purchased + total.collection_count_not_purchased }}шт
                                </template>
                                {{ total.order_count_not_purchased + total.collection_count_not_purchased }}<span
                                class="text--secondary">шт</span>
                            </total-cell>
                            <total-cell :error="error_total_loading" :loading="total_loading" cols="6"
                                        title="Cумма невыкупа">
                                <template #default>
                                    {{ +(order_total_not_purchased + collection_total_not_purchased).toFixed(2) }}<span
                                    class="text--secondary">₽</span>
                                </template>
                                <template #tooltip>
                                    Заказы:<br>{{
                                        +(total.order_price_not_purchased - total.order_prepayment_not_purchased).toFixed(2)
                                    }}₽ + %({{ total.order_org_not_purchased }}₽) = {{ order_total_not_purchased }}₽<br>
                                    <v-divider color="white" class="my-1"></v-divider>
                                    Сборы:<br>{{
                                        +(total.collection_price_not_purchased - total.collection_prepayment_not_purchased).toFixed(2)
                                    }}₽ + %({{ total.collection_org_not_purchased }}₽) =
                                    {{ collection_total_not_purchased }}₽<br>
                                    <v-divider color="white" class="my-1"></v-divider>
                                    Итого:<br>{{
                                        +(total.order_price_not_purchased + total.collection_price_not_purchased - total.order_prepayment_not_purchased - total.collection_prepayment_not_purchased).toFixed(2)
                                    }}₽ + %({{
                                        +(total.order_org_not_purchased + total.collection_org_not_purchased).toFixed(2)
                                    }}₽) = {{
                                        +(order_total_not_purchased + collection_total_not_purchased).toFixed(2)
                                    }}₽
                                </template>
                            </total-cell>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row>
                            <total-cell :error="error_total_loading" :loading="total_loading" cols="6" sm="6"
                                        title="Доп. затраты">
                                {{ total.sum_expenses }}<span class="text--secondary">₽</span>
                            </total-cell>
                            <total-cell :error="error_total_loading" :loading="total_loading" cols="6" sm="6"
                                        title="Списания за доставку">
                                {{ total.sum_delivery }}<span class="text--secondary">₽</span>
                            </total-cell>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row>
                            <total-cell :error="error_total_loading" :loading="total_loading" cols="6" sm="6"
                                        title="Доп. услуги">
                                {{ total.sum_service }}<span class="text--secondary">₽</span>
                            </total-cell>
                            <total-cell :error="error_total_loading" :loading="total_loading" cols="6" sm="6"
                                        title="Сумма предоплат">
                                {{ +(total.order_prepayment_all + total.collection_prepayment_all).toFixed(2) }}<span
                                class="text--secondary">₽</span>
                                <template v-slot:tooltip>
                                    Заказы({{ total.order_prepayment_all }}₽)
                                    + Сборы({{ total.collection_prepayment_all }}₽)
                                    = {{ +(total.order_prepayment_all + total.collection_prepayment_all).toFixed(2) }}₽
                                </template>
                            </total-cell>
                        </v-row>

                    </v-container>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <v-divider></v-divider>

        <v-container fluid class="py-0">
            <v-row>
                <v-col class="pb-1 pb-sm-3">
                    <v-btn v-if="has_perm('market_purchase')"
                           color="primary"
                           min-width="130"
                           :to="{name: 'purchase_market', params: {purchase_id: purchase.id}}"
                           class="btn mr-2 mb-2 mb-sm-0">
                        Рынок
                    </v-btn>
                    <v-btn v-else
                           color="primary"
                           min-width="130"
                           :to="{name:'purchase_albums', params: {client_id: current_client.id, purchase_id: purchase.id}}"
                           class="btn body-2 mr-2 mb-2 mb-sm-0">
                        Участвовать
                    </v-btn>
                    <v-menu bottom left transition="slide-y-transition">
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" rounded outlined
                                   class="btn-gray text-none font-weight-regular body-2 mb-2 mb-sm-0">
                                Доп. функции
                                <v-icon right>{{ icon_menu }}</v-icon>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item
                                :to="{name:'purchase_albums', params: {client_id: current_client.id, purchase_id: purchase.id}}"
                                v-if="has_perm('market_purchase')">
                                <v-list-item-title>Участвовать</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                :to="{name:'collections_sort', params: {purchaseId: purchase.id}}"
                                v-if="has_perm('market_purchase')">
                                <v-list-item-title>Сортировка сборов</v-list-item-title>
                            </v-list-item>
                            <v-list-item :to="{name: 'purchase_histories', params: {purchase_id: purchase.id}}">
                                <v-list-item-title>История закупки</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                :to="{name:'purchase_clients', params: {purchase_id: purchase.id}}"
                                v-if="has_perm('clients_purchase')">
                                <v-list-item-title>Клиенты закупки</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                @click="openRecalculationPercentDialog"
                                v-if="has_perm('recalculation_percent_purchase')">
                                <v-list-item-title>Перерасчет процентов</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                :to="{name:'purchase_purchasers', params: {purchase_id: purchase.id}}"
                                v-if="has_perm('purchasers_purchase')">
                                <v-list-item-title>Закупщики</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                :to="{name:'purchase_share_link', params: {purchase_id: purchase.id}}"
                                v-if="has_perm('share_link_purchase')">
                                <v-list-item-title>Ссылки продавцам</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                @click="onDownloadPurchase"
                                v-if="has_perm('download_purchase')">
                                <v-list-item-title>Выгрузить закупку в таблицу</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
import {
    mdiCalendarMonth,
    mdiCheckOutline, mdiClock,
    mdiCloseOutline, mdiCog,
    mdiDotsVertical, mdiHelpCircle,
    mdiMenuDown,
    mdiPencil,
    mdiTrashCan,
    mdiPin, mdiPinOff
} from '@mdi/js';
import { formatDistance } from 'date-fns'
import { ru } from 'date-fns/locale'
import { mapActions, mapGetters, mapState } from "vuex";
import DatetimePicker from "../utils/DateTimePicker";
import TotalCell from "../utils/TotalCell";
import EventBus from "../../event-bus";

export default {
    name: "Purchase",
    components: {TotalCell, 'v-datetime-picker': DatetimePicker},
    props: {
        purchase: {
            required: true,
        }
    },
    data() {
        return {
            icon_calendar: mdiCalendarMonth,
            icon_clock: mdiClock,
            icon_check: mdiCheckOutline,
            icon_close: mdiCloseOutline,
            icon_tooltip: mdiDotsVertical,
            icon_help: mdiHelpCircle,
            icon_menu: mdiMenuDown,
            icon_settings: mdiCog,

            before_edit_purchase: {},

            show_total: undefined,
            save_loading: false,
            total_loading: true,
            error_total_loading: false,
            delete_loading: false,
            edit_mode: false,
            delete_mode: false,
            valid: false,
            rules: {
                title: [
                    value => !!value || 'Обязательно для заполнения',
                    value => (value && value.length >= 2) || 'Минимум 2 символа.',
                ],
                required: [
                    value => !!value || 'Обязательно для заполнения',
                ],
            }
        }
    },
    computed: {
        ...mapGetters('clients', [
            'has_perm',
        ]),
        ...mapState('clients', [
            'current_client',
        ]),
        items() {
            return [
                {
                    title: this.purchase.pinned ? 'Открепить' : 'Закрепить',
                    icon: this.purchase.pinned ? mdiPinOff : mdiPin,
                    disabled: () => this.edit_disabled,
                    action: () => {
                        this.onPin();
                    },
                },
                {
                    title: 'Изменить',
                    icon: mdiPencil,
                    disabled: () => this.edit_disabled,
                    action: () => {
                        this.startEdit();
                    },
                },
                {
                    title: 'Удалить',
                    color: 'red',
                    icon: mdiTrashCan,
                    disabled: () => this.delete_disabled,
                    action: () => {
                        this.delete_mode = true;
                    },
                },
            ]
        },
        order_total_all() {
            return +(this.total.order_price_all + this.total.order_org_all - this.total.order_prepayment_all).toFixed(2)
        },
        collection_total_all() {
            return +(this.total.collection_price_all + this.total.collection_org_all - this.total.collection_prepayment_all).toFixed(2)
        },
        order_total_purchased() {
            return +(this.total.order_price_purchased + this.total.order_org_purchased - this.total.order_prepayment_purchased).toFixed(2)
        },
        collection_total_purchased() {
            return +(this.total.collection_price_purchased + this.total.collection_org_purchased - this.total.collection_prepayment_purchased).toFixed(2)
        },
        order_total_not_purchased() {
            return +(this.total.order_price_not_purchased + this.total.order_org_not_purchased - this.total.order_prepayment_not_purchased).toFixed(2)
        },
        collection_total_not_purchased() {
            return +(this.total.collection_price_not_purchased + this.total.collection_org_not_purchased - this.total.collection_prepayment_not_purchased).toFixed(2)
        },
        buyout_date_start: {
            get() {
                return this.purchase.buyout_date_start
            },
            set(value) {
                this.purchase.buyout_date_start = value
            }
        },
        buyout_date_end: {
            get() {
                return this.purchase.buyout_date_end
            },
            set(value) {
                this.purchase.buyout_date_end = value
            }
        },
        load_date_start: {
            get() {
                return this.purchase.load_date_start
            },
            set(value) {
                this.purchase.load_date_start = value
            }
        },
        load_date_end: {
            get() {
                return this.purchase.load_date_end
            },
            set(value) {
                this.purchase.load_date_end = value
            }
        },
        pay_date_end: {
            get() {
                return this.purchase.pay_date_end
            },
            set(value) {
                this.purchase.pay_date_end = value
            }
        },
        buyout_days_left() {
            let start = this.localDate(this.purchase.buyout_date_start);
            let end = this.localDate(this.purchase.buyout_date_end);
            return this.daysLeft(start, end);
        },
        load_days_left() {
            let start = this.localDate(this.purchase.load_date_start);
            let end = this.localDate(this.purchase.load_date_end);
            return this.daysLeft(start, end);
        },
        pay_days_left() {
            let start = this.$dateNow();
            let end = this.localDate(this.purchase.pay_date_end);
            return this.daysLeft(start, end);
        },
        edit_disabled() {
            return !this.has_perm('edit_purchase')
        },
        delete_disabled() {
            return !this.has_perm('delete_purchase')
        },
        total() {
            const vm = this;
            if (vm.purchase.total !== undefined) {
                for (let key in vm.purchase.total) {
                    vm.purchase.total[key] = +vm.purchase.total[key].toFixed(2)
                }
                return vm.purchase.total
            } else {
                return {}
            }
        }
    },
    watch: {
        'purchase.backorder': {
            handler: function (val) {
                if (val) {
                    console.log('EDIT BACKORDER')
                    this.purchase.load_date_start = this.$dateNow().toISOString();
                    this.purchase.load_date_end = this.purchase.buyout_date_end;
                    // if (this.purchase.load_date_end) {
                    //     if (Date.parse(this.purchase.load_date_end) < Date.parse(this.purchase.load_date_start)) {
                    //         let date = new Date()
                    //         this.purchase.load_date_end = new Date(date.setDate(date.getDate() + 1)).toISOString();
                    //     }
                    // } else {
                    //     let date = new Date()
                    //     this.purchase.load_date_end = new Date(date.setDate(date.getDate() + 1)).toISOString();
                    // }
                }
            }
        }
    },
    methods: {
        ...mapActions('purchases', [
            'editPurchase',
            'deletePurchase',
            'getTotalPurchase',
            'togglePinPurchase'
        ]),
        onPin() {
            this.togglePinPurchase(this.purchase.id);
        },
        onSettingsBackorder() {
            EventBus.$emit('settings_backorder_dialog', this.purchase)
        },
        openRecalculationPercentDialog() {
            EventBus.$emit('recalculation_percent_dialog', this.purchase)
        },
        onShowTotal() {
            if (this.show_total === undefined) {
                this.total_loading = true;
                this.error_total_loading = false;
                this.getTotalPurchase(this.purchase.id)
                    .then(() => {
                        this.total_loading = false;
                    })
                    .catch(() => {
                        this.total_loading = false;
                        this.error_total_loading = true;
                    });
            }
        },
        startEdit() {
            Object.assign(this.before_edit_purchase, this.purchase);
            this.edit_mode = true;
        },
        cancelEdit() {
            Object.assign(this.purchase, this.before_edit_purchase);
            this.edit_mode = false;
        },
        localDate(date_str) {
            let time = Date.parse(date_str);
            // return new Date(time - new Date().getTimezoneOffset() * 60 * 1000);
            return new Date(time);
        },
        daysLeft(start, end) {
            const now = this.$dateNow();
            if (end <= now) {
                return -1
            }

            let text = 'Осталось'
            let date = end;
            if (start > now) {
                text = 'Через'
                date = start
            }

            const distance = formatDistance(
                date,
                now,
                {locale: ru} // Pass the locale as an option
            );

            return ` - <div class="badge">${text} ${distance}</div>`
        },
        onSave() {
            this.save_loading = true;
            this.editPurchase(this.purchase)
                .then(() => {
                    this.save_loading = false;
                    this.edit_mode = false;
                })
                .catch(() => {
                    this.save_loading = false;
                });
        },
        onDelete() {
            this.delete_loading = true;
            this.deletePurchase(this.purchase.id)
                .catch(() => {
                    this.delete_loading = false;
                })
        },
        onDownloadPurchase() {
            EventBus.$emit('download_purchase_dialog', this.purchase.id)
        }
    },
}
</script>

<style>
.btn-gray {
    border-color: lightgray !important;
}

.btn-gray:hover {
    border-color: rgba(0, 0, 0, .87) !important;
}

.badge {
    display: inline-block;
    background-color: #f2f2f2;
    padding: 0 5px;
    border: solid lightgray 1px;
    border-radius: 5px;
}
</style>